import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import TimeTrackingDatePicker from 'modules/attendance/components/ClockIn/AdminLayout/WeeklyView/TimeTrackingDatePicker'
import { Cycle } from 'modules/attendance/lib/attendanceDateNavigatorContext'

const DailyBodyHeader = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onDateChange = (newDateFrom: Date, _newDateTo: Date, cycle: Cycle) => {
    navigate(
      navigation.clockIn.periodTypeYearMonthDay.fullPath({
        periodType: cycle,
        year: newDateFrom.getFullYear(),
        month: newDateFrom.getMonth() + 1,
        day: newDateFrom.getDate(),
      })
    )
  }

  return (
    <Box alignItems="flexEnd" paddingBottom="s24">
      <TimeTrackingDatePicker regularPeriods={['week', 'month']} onChange={onDateChange} />
    </Box>
  )
}

export default DailyBodyHeader
